(function () {
    const OriginalXHR = window.XMLHttpRequest;

    function ModifiedXHR() {
        const xhr = new OriginalXHR();

        const originalOpen = xhr.open;
        const originalSend = xhr.send;

        let targetUrl = "";

        xhr.open = function (method, url, async, user, password) {
        targetUrl = url;
        return originalOpen.call(this, method, url, async, user, password);
        };

        xhr.send = function (body) {
        if (targetUrl.includes("/apps/wpdapp/api/order/net-draft") && body) {
            try {
            let data = JSON.parse(body);
            data.wcp_cart.items.forEach((item) => {
                data.wcp_cart.note += `\n[SKU: ${item.original_item.sku}, Price per item: ${wpdCustomFormatPrice(item.wcp_v_price)}]`;
            });
            data.note_data["Notes"] += data.wcp_cart.items.map(item => ` <p>[SKU: ${item.original_item.sku}, Price per item: ${wpdCustomFormatPrice(item.wcp_v_price)}]</p>`).join('');
            return originalSend.call(this, JSON.stringify(data));
            } catch (e) {
                console.warn("Could not parse or modify XHR payload:", e);
            }
        }
        return originalSend.call(this, body);
        };
        return xhr;
    }

    window.XMLHttpRequest = ModifiedXHR;
})();

function wpdCustomFormatPrice(price) {
    return window.WPDMoneyFormat.replace(/({{\s*amount\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
      .replace(/({{\s*amount_no_decimals\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
      .replace(/({{\s*amount_with_comma_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/({{\s*amount_no_decimals_with_comma_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/({{\s*amount_with_apostrophe_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace(/({{\s*amount_no_decimals_with_space_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
      .replace(/({{\s*amount_with_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, " "))
      .replace(/({{\s*amount_with_period_and_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ".").replace(/\B(?=(\d{3})+(?!\d))/g, " "));
}